import {
  AUTH_USER_REQUEST,
  AUTH_USER,
  UNAUTH_USER,
  AUTH_ERROR,
  FETCH_MESSAGE,
} from '../actions/types'

export default function(state = {}, action) {
  switch (action.type) {
    case AUTH_USER_REQUEST:
      return {...state, loading: action.payload.loading}
    case AUTH_USER:
      return {...state, error: '', authenticated: true}
    case UNAUTH_USER:
      return {...state, authenticated: false}
    case AUTH_ERROR:
      return {...state, error: action.payload}
    case FETCH_MESSAGE:
      return {...state, message: action.payload}
    default:
      return {...state}
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/auth_reducer.js
 **/